import React from "react";
import type { DateDetails, UpcomingEvent, VenueDetails } from "./types";
import { CalendarDays, MapPin } from "lucide-react";
import { sanitizedHtml } from "../../utils/sanitize";

function CalendarEventCard({ title, url, start_date_details, end_date_details, venue, description }: UpcomingEvent) {
  const formatDateTime = (d: DateDetails) => {
    const date = new Date(d.year, d.month - 1, d.day, d.hour, d.minutes);
    const month = date.toLocaleString("default", { month: "short" });
    const display_time = date.toLocaleTimeString( [], { hour: "numeric", minute: "2-digit" } ).toLowerCase();
    return `${month} ${String(d.day).padStart(2, '0')} @ ${display_time}`;
  };

  const getDateDisplay = (d: DateDetails) => {
    const date = new Date(d.year, d.month - 1, d.day);
    return {
      day: date.getDate(),
      month: date.toLocaleString("default", { month: "short" })
    };
  };

  const htmlParser = new DOMParser();
  const isVenue = (v: typeof venue): v is VenueDetails => !!Object.keys(v).length;

  const addressString = isVenue(venue)
    ? `${htmlParser.parseFromString(venue.venue, "text/html").body.innerText}, ${venue.address} ${venue.city}`
    : "Virtual";

  const startDisplay = getDateDisplay(start_date_details);

  return (
    <a href={url} target="_blank" rel="noreferrer" className="calendar-event event-link">
      <div className="event-date-badge">
        <div className="date-day">{startDisplay.day}</div>
        <div className="date-month">{startDisplay.month}</div>
      </div>
      <div className="event-content">
        <h3 className="event-title" dangerouslySetInnerHTML={sanitizedHtml(title)} />

        <div className="event-details">
          <div className="event-datetime">
            <CalendarDays />
            <span>{`${formatDateTime(start_date_details)} - ${formatDateTime(end_date_details)}`}</span>
          </div>

          <div className="event-location">
            <MapPin />
            <span>{addressString}</span>
          </div>
        </div>
      </div>
    </a>
  );
}

export default CalendarEventCard;
